import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { listCopy, ListCopy } from 'lib/listCopy'

// The sanctioned home of the `grouped-navigation` literal (a repo script generates the toggle-name
// list from literals, so a constant here would leave the toggle silently dead); not a wrapper for
// its own sake.
export function useListCopy(): ListCopy {
  return listCopy(useFeatureToggle(`grouped-navigation`))
}
